import { useEffect, useState } from "react"
import { useRef } from 'react'
import ReactDOM from 'react-dom'
import '../helper/Toast.css'
import '../helper/Modal.css'

export const useModal =(closeCallback=()=>{})=>{


    const [modal, setModal] = useState(null)

    const modalRef = useRef(null)


    const closeModal = () =>{
        setModal(null)
        closeCallback()
    }

    const handleClick =e=>{
        if(e.target !== modalRef.current){
            return
        }else{
            closeModal();
        }
    }

    // useEffect(() => {
    //     document.body.style.overflow = 'hidden'

    //     return ()=> document.body.style.overflow = 'unset'
    // }, [])



    function showModal(modalContent){
        setModal(ReactDOM.createPortal((
            <div onClick={handleClick} className="modal-container-backdrop" ref={modalRef}>
                <div className="modal-container">
                    <img onClick={closeModal} src="/icons/close_black_48dp.svg" alt="" className="modal-close" />
                    {modalContent}
                </div>
            </div>
        ), document.getElementById('modal')))
    }

    return { showModal, closeModal, modal }

}